import { getColorConfig } from 'utils/StyleUtils';
import { PiShoppingCartDuotone, PiTrashDuotone, PiWalletDuotone } from 'react-icons/pi';
import Modal from 'components/Modal';
import { useShop } from 'providers/ShopProvider';

export default function DetailModal({ isOpen, onClose, onOpenBasket, item, color }) {
    const gradientConfig = color ? getColorConfig(color) : { gradient: 'bg-gray-500', "gradient-end": 'to-gray-600' };
    const gradientClass = `${gradientConfig.gradient} ${gradientConfig["gradient-end"]}`;
    const { basket, isInBasket, addToBasket, removeFromBasket } = useShop();
    const inBasket = item ? isInBasket(item.id) : false;

    if (!isOpen || !item) return null;

    return (
        <Modal open={isOpen} onClose={onClose} maxWidth="max-w-[520px]" className="!w-full">
            <div className="flex flex-col">
                <div className="flex w-full items-center justify-between gap-4 px-5 py-4 text-white">
                    <h2 className="min-w-0 font-display text-2xl font-black leading-tight sm:text-3xl">
                        {item.name}
                    </h2>
                    <button
                        type="button"
                        onClick={onOpenBasket}
                        aria-label={`Kosár megnyitása, ${basket.length} termék`}
                        title="Kosár megnyitása"
                        className="group relative flex size-11 shrink-0 items-center justify-center rounded-xl bg-white/15 text-white transition hover:bg-white/25"
                    >
                        <PiShoppingCartDuotone className="size-6 transition group-hover:scale-110" />
                        {basket.length > 0 && (
                            <span className="gradient-yellow absolute -right-1.5 -top-1.5 flex size-5 items-center justify-center rounded-full text-[10px] font-black shadow-md">
                                {basket.length}
                            </span>
                        )}
                    </button>
                </div>

                <div className="mx-2 overflow-hidden rounded-2xl bg-white text-neutral-900 shadow-2xl">
                    <img
                        src={`${global.backingsEndpoint}photoRepository/getImageBySize?size=ORIGINAL&key=${item.photo}`}
                        alt={item.name}
                        className="aspect-[4/3] w-full object-cover"
                    />

                    <div className="space-y-4 p-5">
                        <div className="flex items-center justify-between gap-4">
                            <p className={`flex shrink-0 items-center gap-2 rounded-xl px-3 py-2 font-display text-lg font-black text-white ${gradientClass}`}>
                                <PiWalletDuotone /> {item.pointsPrice} pont
                            </p>
                            {item.vip && (
                                <span className="rounded-full bg-amber-100 px-3 py-1 text-xs font-black text-amber-700">VIP termék</span>
                            )}
                        </div>
                        <p className="text-sm leading-relaxed text-neutral-600">
                            {item.description}
                        </p>
                    </div>
                </div>

                <div className="w-full p-4">
                    <button
                        type="button"
                        onClick={() => inBasket ? removeFromBasket(item.id) : addToBasket(item.id)}
                        className={`${inBasket ? 'gradient-red' : gradientClass} flex w-full items-center justify-center gap-2 rounded-xl p-3.5 font-black text-white transition hover:-translate-y-0.5 hover:brightness-110 hover:shadow-xl`}
                    >
                        {inBasket ? <PiTrashDuotone className="size-5" /> : <PiShoppingCartDuotone className="size-5" />}
                        {inBasket ? 'Kiveszem a kosárból' : 'Kosárba teszem'}
                    </button>
                </div>
            </div>
        </Modal>
    );
}
